// extracted by css-extract-rspack-plugin
export default {"settings":"TGheQcWdghQqm2CS","layout":"uotrfeVHp38SjAAA"};